'use strict';

import React from 'react';
import Linkify from 'react-linkify';

const get_text_as_jsx = function (raw_text) {

  if (typeof(raw_text) == 'undefined' || raw_text == null) {
    return null;
  }

  // Divide into paragraphs where there are two returns in a row.
  var paragraphs = raw_text.split(/[\r\n][\r\n]/)

  var text_as_jsx = [];
  for (var paragraph_index = 0; paragraph_index < paragraphs.length; paragraph_index++) {

    if (paragraphs[paragraph_index].startsWith('## ')) {
      text_as_jsx.push(<h2 key={paragraph_index}>{paragraphs[paragraph_index].substring(2)}</h2>);
    }
    else {

      // Divide remaining lines by single line breaks.
      var paragraph_lines = paragraphs[paragraph_index].split(/[\r\n]/);

      var paragraph = [];
      for (var i = 0; i < paragraph_lines.length; i++) {

        // Add each line and turn urls into links.
        paragraph.push(<Linkify key={'line-' + i} properties={{target: "_blank"}}>{paragraph_lines[i]}</Linkify>);

        // Add br tags where there are single line breaks.
        if (i < paragraph_lines.length - 1) {
          paragraph.push(<br key={'br-' + i} />);
        }

      }

      text_as_jsx.push(<p key={paragraph_index}>{paragraph}</p>);
    }

  }
  return text_as_jsx;
}

export default get_text_as_jsx
